import styled from '@emotion/styled';

const ArticleAssetCaptionContainer = styled('div')({
  marginTop: '1.6rem',
});

export default ArticleAssetCaptionContainer;
